import { useMutation, UseMutationOptions } from "@connectrpc/connect-query";

import {
  completeOperationUpload,
  completePartUpload,
  createUploadSync,
  getUploadSync,
  initiateUpload,
} from "@gx/ts-contracts/services/uploader/api/uploader-UploadService_connectquery";

// ========== CREATE UPLOAD SYNC ==========

export const useCreateUploadSyncMutation = (
  options?: UseMutationOptions<typeof createUploadSync.input, typeof createUploadSync.output>,
) => {
  return useMutation<typeof createUploadSync.input, typeof createUploadSync.output>(
    createUploadSync,
    options,
  );
};

// ========== INITIATE UPLOAD ==========

export const useInitiateUploadMutation = (
  options?: UseMutationOptions<typeof initiateUpload.input, typeof initiateUpload.output>,
) => {
  return useMutation<typeof initiateUpload.input, typeof initiateUpload.output>(
    initiateUpload,
    options,
  );
};

// ========== COMPLETE PART UPLOAD ==========

export const useCompletePartUploadMutation = (
  options?: UseMutationOptions<typeof completePartUpload.input, typeof completePartUpload.output>,
) => {
  return useMutation<typeof completePartUpload.input, typeof completePartUpload.output>(
    completePartUpload,
    options,
  );
};

// ========== COMPLETE OPERATION UPLOAD ==========

export const useCompleteOperationUploadMutation = (
  options?: UseMutationOptions<
    typeof completeOperationUpload.input,
    typeof completeOperationUpload.output
  >,
) => {
  return useMutation<typeof completeOperationUpload.input, typeof completeOperationUpload.output>(
    completeOperationUpload,
    options,
  );
};

// ========== GET UPLOAD SYNC ==========

export const useGetUploadSyncMutation = (
  options?: UseMutationOptions<typeof getUploadSync.input, typeof getUploadSync.output>,
) => {
  return useMutation<typeof getUploadSync.input, typeof getUploadSync.output>(
    getUploadSync,
    options,
  );
};
